import lodashUniq from 'lodash/fp/uniq';
import lodashKeyBy from 'lodash/fp/keyBy';
import lodashDefaultsDeep from 'lodash/fp/defaultsDeep';
import typeCheck from 'common/util/typeCheck';

import { hideFieldIf } from 'client/helpers/formikHelpers';

import { MARKETING_PARTNER_LISTING_TEMPORARILY_OFF_MARKET_REASON_OPTION_ITEMS } from 'common/marketingPartnerListingConstants';

const marketingPartnerListingFormFields = [
  {
    id: 'status',
    title: 'Status',
    type: 'select',
  },
  {
    id: 'temporarilyOffMarketReason',
    title: 'Reason for Temp. Off-Market?',
    type: 'select',
    properties: {
      choices: MARKETING_PARTNER_LISTING_TEMPORARILY_OFF_MARKET_REASON_OPTION_ITEMS,
    },
  },
  {
    id: 'temporarilyOffMarketReasonProvided',
    title: 'Other Reason for Temp. Off-Market?',
    type: 'long_text',
  },
  {
    id: 'bringBackToMarketDate',
    title: 'Bring Back On Market Date',
    type: 'date_picker',
    properties: {
      placeholder: 'MM/DD/YYYY',
      dateFormat: 'MM/DD/YYYY',
    },
  },
  {
    id: 'withdrawalReason',
    title: 'Reason for withdrawing?',
    type: 'select',
  },
  {
    id: 'withdrawalReasonProvided',
    title: 'Other reason for withdrawing',
    type: 'long_text',
  },
];

const marketingPartnerListingFormFieldsById = lodashKeyBy('id', marketingPartnerListingFormFields);

export default function getMarketingPartnerListingFormFields(params) {
  typeCheck('params::NonEmptyObject', params);
  typeCheck('formType::Maybe NonEmptyString', params.formType);
  typeCheck('fieldgroup::Maybe Array', params.fieldgroup);

  const fieldgroup = params.fieldgroup || [];
  const updates = params.updates || {};
  const isRequired = params.required || false;

  typeCheck('updates::Object', updates);

  return fieldgroup
    .filter((listingFieldId) => marketingPartnerListingFormFieldsById[listingFieldId])
    .map((listingFieldId) => {
      const defaultFieldProperties =
        marketingPartnerListingFormFieldsById[listingFieldId].properties || {};
      const defaultFieldValidations =
        marketingPartnerListingFormFieldsById[listingFieldId].validations || [];

      const formFieldProperties = updates[listingFieldId].properties || {};
      const formFieldValidations = updates[listingFieldId].validations || [];

      const listingFormField = lodashDefaultsDeep(
        {
          ...marketingPartnerListingFormFieldsById[listingFieldId],
          validations: lodashUniq([...defaultFieldValidations, ...formFieldValidations]),
          properties: {
            ...defaultFieldProperties,
            ...formFieldProperties,
          },
        },
        updates[listingFieldId],
      );

      if (isRequired && !listingFormField.validations.includes('required')) {
        listingFormField.validations.unshift('required');
      }

      return hideFieldIf(listingFormField.hideFieldIf, listingFormField);
    });
}
